function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistoryModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "order_history_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 133 \\u2013 92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M5.667 8.368h10.666V6.579H5.667zM3 20V4.789a1.731 1.731 0 0 1 .522-1.264A1.708 1.708 0 0 1 4.778 3h12.444a1.708 1.708 0 0 1 1.256.525A1.731 1.731 0 0 1 19 4.789v5.972a5.415 5.415 0 0 0-1.3-.459 6.524 6.524 0 0 0-1.367-.145H5.667v1.789h6.311a6.892 6.892 0 0 0-.7.828 6.2 6.2 0 0 0-.566.962H5.667v1.789h4.511a3.1 3.1 0 0 0-.056.437q-.011.212-.011.458a6.179 6.179 0 0 0 1.022 3.445L11 20l-1.333-1.342L8.333 20 7 18.658 5.667 20l-1.334-1.342z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M18 23a4.993 4.993 0 0 1-5-5 4.993 4.993 0 0 1 5-5 4.992 4.992 0 0 1 5 5 4.992 4.992 0 0 1-5 5zm1.65-2.65.7-.7-1.85-1.85V15h-1v3.2z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryModern);
export default __webpack_public_path__ + "static/media/order_history_modern.6afd45a77ca1d3930480b838171d2574.svg";
export { ForwardRef as ReactComponent };